import { createStore } from 'vuex'
import auth from './modules/auth';
import travelList from './modules/travelList';
import travelListZone from './modules/travelListZone';
import voteStoreData from './modules/voteStore';
// import promotionList from './modules/promotionList';

export default createStore({
  modules: {
    auth, travelList,travelListZone,voteStoreData
  }
});
